import Drawflow from "drawflow";

export default class DrawflowExtended extends Drawflow {

    constructor(container, render = null, parent = null) {
        super(container, render, parent);
    }

    removeNodeId(id) {
        let moduleName = this.getModuleFromNodeId(id.slice(5))
        const removedNode = structuredClone(this.drawflow.drawflow[moduleName].data[id.slice(5)]);
        this.removeConnectionNodeId(id);
        if(this.module === moduleName) {
            const el = this.container.querySelector(`#${id}`);
            if (el) el.remove();
        }
        delete this.drawflow.drawflow[moduleName].data[id.slice(5)];
        this.dispatch('nodeRemoved', removedNode);
    }
}
